module.exports = __webpack_public_path__ + "img/Ident-4-mobile.6b8b7830.png";